import styled from 'styled-components';

export const Container = styled.div``;

export const ImageContainer = styled.div`
    display: flex;
    border-radius: 6px;
    justify-content: center;
    align-items: center;
    height: 170px;
    width: 170px;
    cursor: pointer;
    border: 1px solid ${(props) => props.theme.color.grey3};
    background-color: ${(props) => props.theme.color.grey2};
    :hover {
        background-color: ${(props) => props.theme.color.grey3};
        border: 1px solid ${(props) => props.theme.color.grey4};
    }
`;

export const LabelContainer = styled.label``;

export const LabelField = styled.p`
    width: 100%;
    color: ${(props) => props.theme.color.grey5};
`;
